import { ConfirmationDataState, ConfirmationDataStructure } from '@/contracts/store/ConfirmationDataContracts'

export const ConfirmationData =
{
    namespaced: true,
    state: (): ConfirmationDataState => (
    {
        confirmationExists: false,
        confirmationData: {} as ConfirmationDataStructure
    }),
    getters:
    {
        confirmationExists(state: ConfirmationDataState): boolean
        {
            return state.confirmationExists
        },
        confirmationData(state: ConfirmationDataState): ConfirmationDataStructure
        {
            return state.confirmationData
        }
    },
    mutations:
    {
        setConfirmationData(state: ConfirmationDataState, data: ConfirmationDataStructure): void
        {
            state.confirmationExists = true
            state.confirmationData = data
        },
        resetConfirmationData(state: ConfirmationDataState): void
        {
            state.confirmationExists = false
            state.confirmationData = {} as ConfirmationDataStructure
        }
    }
}
